/* global window, document, fetch */

/**
 * AppaltiMap Gateway client (pure frontend).
 * All API calls MUST go through the API Gateway.
 */
(function (window) {
    window.AppaltiMap = window.AppaltiMap || {};

    function stripTrailingSlash(url) {
        return (url || '').replace(/\/+$/, '');
    }

    function TokenStore(storageKey) {
        this._key = storageKey || 'appaltimap_auth';
    }

    TokenStore.prototype.get = function () {
        try {
            var raw = window.localStorage.getItem(this._key);
            if (!raw) return null;
            return JSON.parse(raw);
        } catch (e) {
            return null;
        }
    };

    TokenStore.prototype.getToken = function () {
        var data = this.get();
        if (!data || !data.token || !data.expiresAt) return null;
        if (Date.now() >= data.expiresAt) return null;
        return data.token;
    };

    TokenStore.prototype.setExchange = function (token, expiresInSeconds) {
        var expiresAt = Date.now() + (Number(expiresInSeconds) || 0) * 1000;
        var data = {token: token, expiresAt: expiresAt};
        try {
            window.localStorage.setItem(this._key, JSON.stringify(data));
        } catch (e) {
            // ignore storage failures (private mode etc.)
        }
        return data;
    };

    function ApiGatewayClient(options) {
        options = options || {};
        this.baseUrl = stripTrailingSlash(options.baseUrl || '');
        this.tokenStore = options.tokenStore || new TokenStore();
        var mu = (options.memberUuid != null && String(options.memberUuid).trim()) || '';
        this.memberUuid = mu || null;
    }

    ApiGatewayClient.prototype._headers = function () {
        var headers = {'Accept': 'application/json'};
        var token = this.tokenStore.getToken();
        if (token) headers.Authorization = 'Bearer ' + token;
        if (this.memberUuid) headers['X-Member-UUID'] = this.memberUuid;
        return headers;
    };

    ApiGatewayClient.prototype.exchangeToken = function (magic) {
        var url = this.baseUrl + '/auth/exchange?magic=' + encodeURIComponent(magic);
        return fetch(url, {method: 'GET', headers: this._headers()})
            .then(function (r) {
                if (!r.ok) throw r;
                return r.json();
            });
    };

    ApiGatewayClient.prototype.getClusters = function (params) {
        var url = new URL(this.baseUrl + '/clusters', window.location.origin);
        Object.keys(params || {}).forEach(function (k) {
            if (params[k] !== null && params[k] !== undefined) url.searchParams.set(k, params[k]);
        });
        return fetch(url.toString(), {method: 'GET', headers: this._headers()})
            .then(function (r) {
                if (!r.ok) throw r;
                return r.json();
            });
    };

    ApiGatewayClient.prototype.getTenders = function (params) {
        var url = new URL(this.baseUrl + '/tenders', window.location.origin);
        Object.keys(params || {}).forEach(function (k) {
            if (params[k] !== null && params[k] !== undefined) url.searchParams.set(k, params[k]);
        });
        return fetch(url.toString(), {method: 'GET', headers: this._headers()})
            .then(function (r) {
                if (!r.ok) throw r;
                return r.json();
            });
    };

    function _appendSearchParams(url, params) {
        Object.keys(params || {}).forEach(function (k) {
            var v = params[k];
            if (v !== null && v !== undefined && String(v).trim() !== '') {
                url.searchParams.set(k, v);
            }
        });
    }

    ApiGatewayClient.prototype.getRadarHubKpi = function (params) {
        var url = new URL(this.baseUrl + '/radar/hub/kpi', window.location.origin);
        _appendSearchParams(url, params || {});
        return fetch(url.toString(), {method: 'GET', headers: this._headers()})
            .then(function (r) {
                if (!r.ok) throw r;
                return r.json();
            });
    };

    ApiGatewayClient.prototype.getRadarHubSuppliers = function (params) {
        var url = new URL(this.baseUrl + '/radar/hub/suppliers', window.location.origin);
        _appendSearchParams(url, params || {});
        return fetch(url.toString(), {method: 'GET', headers: this._headers()})
            .then(function (r) {
                if (!r.ok) throw r;
                return r.json();
            });
    };

    window.AppaltiMap.TokenStore = TokenStore;
    window.AppaltiMap.ApiGatewayClient = ApiGatewayClient;
})(window);

